export * from './src/i18n.module';
export * from './src/browser-locale/language';
export { bootstrapI18n, setLanguage, getLocale } from './src/browser-locale/browser-locale';
